var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatasetSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m441 140.5v338c0 18.2-14.7 32.9-32.9 32.9h-304.2c-18.2 0-32.9-14.7-32.9-32.9v-445c0-18.2 14.7-32.9 32.9-32.9h197.2z",
    fill: "#7b00b1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m336.9 254.9h-161.8c-5.8 0-10.5 4.7-10.5 10.5v140.9c0 5.8 4.7 10.5 10.5 10.5h161.9c5.8 0 10.5-4.7 10.5-10.5v-140.8c-.1-5.8-4.8-10.6-10.6-10.6zm-151.3 67.6h59.9v26.7h-59.9zm80.9 0h59.9v26.7h-59.9zm59.9-21h-59.9v-25.5h59.9zm-80.9-25.5v25.5h-59.9v-25.5zm-59.9 94.3h59.9v25.5h-59.9zm80.9 25.5v-25.5h59.9v25.5z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m319.9 135.4 121.1 98.1v-92.1l-68.7-39.9z",
    opacity: 0.19
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m441 140.5h-107c-18.2 0-32.9-14.7-32.9-32.9v-107z",
    fill: "#CC0099"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetSheet);
export default __webpack_public_path__ + "static/media/dataset-sheet.2e85dd62.svg";
export { ForwardRef as ReactComponent };